import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import buttonCopy from '@/components/button/copy'
import info from '@/components/info'
import tag from '@/components/tag'

function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.tokens}.warnings.token`),
        color: Colors.error
      }
    }
  )
}
function renderToken(h) {
  return h(
    'div',
    {
      class: `${Services.tokens}-dialog__token`
    },
    [ this.$_token ]
  )
}
function renderSensitivityButton(h) {
  let sensitivityIcon
  let sensitivityColor
  if (this.sensitivity) {
    sensitivityIcon = icons.visibility
    sensitivityColor = Colors.success
  } else {
    sensitivityIcon = icons.visibility_off
    sensitivityColor = Colors.grey
  }

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: sensitivityIcon,
        color: sensitivityColor,
        tooltip: this.getTranslate(`${Services.tokens}.tooltips.sensitivity`)
      },
      on: {
        click: () => {
          this.sensitivity = !this.sensitivity
        }
      }
    }
  )
}
function renderCopyButton(h) {
  return h(
    buttonCopy,
    {
      props: {
        value: this.data?.token,
        mode: buttonModes.flat,
        tooltip: this.getTranslate(`${Services.tokens}.tooltips.copy`),
        snackbar: {
          text: this.getTranslate(`${Services.tokens}.snackbars.copy`),
          type: Colors.success
        }
      }
    }
  )
}
function renderContent(h) {
  if (this.$_token) {
    return h(
      'div',
      {
        class: `${Services.tokens}-dialog__content`
      },
      [
        renderToken.call(this, h),
        renderSensitivityButton.call(this, h),
        renderCopyButton.call(this, h)
      ]
    )
  }
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.tokens}-dialog`
    },
    [
      renderWarning.call(this, h),
      renderContent.call(this, h)
    ]
  )
}

function renderTimer(h) {
  if (this.disabled) {
    return h(
      tag,
      {
        props: {
          label: this.count,
          size: sizes.huge,
          color: Colors.grey,
          monospace: true,
          as: 'button'
        }
      }
    )
  }
}
function renderCloseButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.close'),
        mode: buttonModes.flat,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.proxy = false
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe grid-gap--8 pa-2',
      slot: 'footer'
    },
    [
      renderTimer.call(this, h),
      renderCloseButton.call(this, h)
    ]
  )
}

export default function(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 'max-content'
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.tokens}.titles.copy`),
        value: this.proxy,
        closeOnEsc: false,
        closeOnClick: false,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
